// extracted by mini-css-extract-plugin
export var linkText = "_no-0";